// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{display:block;height:100%}.sankey-widget{height:100%}.sankey-widget mp-sankey-chart:not(.loaded){opacity:.3;pointer-events:none}.sankey-widget mp-context-menu{position:absolute;z-index:7000}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
